import { render, staticRenderFns } from "./investment.vue?vue&type=template&id=998e421c&scoped=true"
import script from "./investment.vue?vue&type=script&lang=js"
export * from "./investment.vue?vue&type=script&lang=js"
import style0 from "./investment.vue?vue&type=style&index=0&id=998e421c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998e421c",
  null
  
)

export default component.exports